<template>
    <div>
        <!-- 功能按钮 -->
        <buttonlist
                @help="help"
                @add="add"
                @reflash="reflash"
                @del="batchDel"
                ref="SetBtn"
        ></buttonlist>
        <!-- 功能按钮 -->
        <!-- 表格 -->
        <el-table
                id="xpane-0"
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="false"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight"
                @cell-dblclick="editInfo"
                tab-click="selectInfo(0)"
                header-row-class-name="headerclass"
                @selection-change="handleSelectionChange"
                style="width: 100%; margin-top:0px"
                :header-cell-style="$limits.headerClass"
                ref="singleTable"
        >
            <el-table-column type="selection"></el-table-column>
            <el-table-column show-overflow-tooltip prop="num" label="ID" v-if="false"></el-table-column>
            <el-table-column show-overflow-tooltip prop="type_name" :label="$t('getapi[3405]')" width="100"></el-table-column>
            <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')" width="100"></el-table-column>
            <!-- <el-table-column show-overflow-tooltip :label="$t('getapi[6048]')" width="80">
                <template slot-scope="scope">
                    <el-button :disabled="!btn.edit" @click.native.prevent="editInfo(scope.row)" type="text"
                               size="small">{{ $t('getapi[34]') }}
                    </el-button>
                    <el-popconfirm
                            :confirmButtonText="$t('getapi[937]')"
                            :cancelButtonText="$t('getapi[6]')"
                            icon="el-icon-info"
                            iconColor="red"
                            :title="$t('getapi[637]')"
                            @onConfirm="del(scope)"
                    >
                        <el-button :disabled="!btn.del" slot="reference" type="text" size="small">{{ $t('getapi[40]')
                            }}
                        </el-button>
                    </el-popconfirm>
                </template>
            </el-table-column> -->
        </el-table>
        <!-- 编辑弹框 -->
        <el-dialog v-dialogDrag :visible.sync="isVisible" :title="$t('getapi[34]')" width="30%" :close-on-click-modal="false">
            <el-divider></el-divider>
			<div :style="{border:'1px solid #DCDFE6'}">
			<table>
				<tr>
					<td>{{$t('getapi[3405]')}}</td>
					<td><el-input v-model="dataList.type_name" type="text" size="mini" ></el-input></td>
                </tr>
				<tr>
                    <td>{{$t('getapi[143]')}}</td>
					<td><el-input v-model="dataList.remark" type="text" size="mini" ></el-input></td>
				</tr>
			</table>
			</div>
			<el-divider></el-divider>

            <span slot="footer" class="dialog-footer">
				<el-button size="small" @click="isVisible = false">{{ $t('getapi[6]') }}</el-button>
				<el-button size="small" type="primary" @click="save" :loading="loading"
                           :disabled="loading">{{ $t('getapi[937]') }}</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';

    export default {
        name: 'purgroup',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                isVisible: false,
                DbTbNames: '', //表名
                userData: [],
                user: "",
                dataSet: [],
                dataList: {},
                PageIndex: 1,
                PageSize: 50,
                SelectIndex: 1,
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                queryData: [], // 查询数组
                selectIDData: [],
                ids: "",
                exclusively_id: '',
                btn: {
                    del: false,
                    edit: false
                },
                scrollTop:0,
            };
        },
        create() {
        },
        beforeMount() {
            console.log('beforeMount');
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted() {
            let that = this;
            that.userData = JSON.parse(sessionStorage.getItem('userData'))
            that.user = that.userData.username
            that.getView();
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[3404]"),this.$t("getapi[11]"));
            },
            //按钮操作权限
            authority() {
                let that = this
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                if(that.$limits.authority('plv2', 76, 1) == 1){
                    that.$refs.SetBtn.SetButtonEnable('refresh');
                }
                if(that.$limits.authority('plv2', 76, 1) == 2){
                    if(that.$limits.authority('plv3', 76, 1) == 0){
                        that.btn.edit = false;
                        that.btn.del = false;
                        that.$refs.SetBtn.SetButtonEnable('refresh');
                    }
                    if(that.$limits.authority('plv3', 76, 1) == 1){
                        that.btn.edit = true;
                        that.btn.del = false;
                        that.$refs.SetBtn.SetButtonEnable('refresh');
                    }
                    if(that.$limits.authority('plv3', 76, 1) == 2){
                        that.btn.edit = true;
                        that.btn.del = true;
                        that.$refs.SetBtn.SetButtonEnable('refresh');
                    }
                }
            },
            //编辑
            editInfo(row) {
                let that = this;
                that.isVisible = true
                that.dataList = {
                    exclusively_id: row.exclusively_id,
                    type_name: row.type_name,
                    remark: row.remark,
                }
            },
            // 获取数据
            getView() {
                let that = this;
                that.loading = true;
                let parm = {};
                that.$http.urlpost('/Basic/WH/GetCargoPositionList', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.DbTbNames = res.DbTbNames;
                    }
                    that.loading = false;
                    that.authority();
                });
            },
            // 保存数据
            save() {
                let that = this;
                that.loading = true;
                let datetime = Common.methods.getDatetime()
                let parm = new Array();
                parm.push({
                    _exclusively_id: that.dataList.exclusively_id,
                    _type_name: that.dataList.type_name,
                    _create_person: that.user,
                    _create_time: datetime,
                    _modify_person: that.user,
                    _modify_time: datetime,
                    _remark: that.dataList.remark,
                    _mrpuse: true
                });
                that.$http.urlpost('/Basic/WH/SaveCargoPosition', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[284]'));
                        that.isVisible = false;
                        that.getView();
                    }
                    that.loading = false;
                });
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectIDData = '';
                for (let i = 0; i < val.length; i++) {
                    that.selectIDData += val[i].exclusively_id + ',';
                }
            },
            // 删除
            delf() {
                let that = this;
                let parm = {
                    ids: that.ids,
                    exclusively_id: ''
                };
                that.$http.urlpost('/Basic/WH/DeleteCargoPositionByID', parm, function (res) {
                    that.getView();
                    that.$message.success(that.$t('getapi[659]'));
                });
            },
            // 删除
            del(row) {
                this.ids = row.row.exclusively_id + ',';
                this.delf();
            },
            //批量删除
            batchDel() {
                let that = this;
                that.ids = this.selectIDData;
                that.$confirm(that.$t('getapi[8594]'), that.$t('getapi[194]'), {//'此操作将永久删除该数据, 是否继续?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        that.delf();
                    })
                    .catch(() => {
                    });
            },
            // 新增
            add() {
                let that = this
                that.isVisible = true;
                that.dataList = {
                    exclusively_id: "",
                    type_name: "",
                    remark: ''
                }
            },
            // 刷新
            reflash() {
                this.getView();
            }
        }
    };
</script>

<style lang="scss" scoped>

table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
.el-form--inline .el-form-item {
	display: flex;
}

.tb-edit .el-input {
	display: none;
}

.tb-edit .current-row .el-input {
	display: block;
}

.tb-edit .current-row .el-input + span {
	display: none;
}

.el-table .hidden-row {
	display: none;
}
</style>
